import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NpAddressSyncPage } from '@features/admin/np-sync';

const searchSchema = z.object({
  // UNCHANGED se v tabulce neukazuje (backend ty radky neposila).
  state: z.enum(['ALL', 'NEW', 'ADOPT', 'CHANGED', 'INVALID', 'OTHER_ORGANIZATION', 'DUPLICATE']).optional().default('ALL'),
  // Hledani ve firme a adrese.
  q: z.string().optional(),
});

export type AdminNpAddressSyncSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/admin/np-address-sync/')({
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  return <NpAddressSyncPage />;
}
